import { render, staticRenderFns } from "./CreateEditSubcategory.vue?vue&type=template&id=1fbe4225&scoped=true"
import script from "./CreateEditSubcategory.vue?vue&type=script&lang=js"
export * from "./CreateEditSubcategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbe4225",
  null
  
)

export default component.exports